/* ===========================================================
   LEBONDEAL — REFONTE 2026
   Moteur d'interactions. Zéro dépendance, ~4 Ko.
   - apparitions au scroll
   - parallaxe légère
   - scènes « pinned » (produit qui se révèle au scroll)
   - accordéons
   - carrousels horizontaux
   - indicateur de progression latéral
   =========================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 0. Conteneur de défilement réel ----------------
     Le thème Horizon fait défiler `.page-wrapper` et non la fenêtre
     quand les transitions de page sont activées. On détecte le vrai
     scroller pour que parallaxe, scènes et progression fonctionnent
     dans les deux configurations. */
  function getScroller() {
    var de = document.scrollingElement || document.documentElement;
    if (de.scrollHeight > de.clientHeight + 4) return de;
    var w = document.querySelector('.page-wrapper');
    if (w && w.scrollHeight > w.clientHeight + 4) return w;
    return de;
  }
  /* `scroll` ne remonte pas, mais il se capture : on écoute donc en phase
     de capture sur document pour attraper n'importe quel scroller. */
  function onAnyScroll(fn) {
    document.addEventListener('scroll', fn, { capture: true, passive: true });
    window.addEventListener('resize', fn, { passive: true });
  }

  /* ---------- 1. Apparitions au scroll ---------------------- */
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.lbd2-rise,.lbd2-fade,.lbd2-zoom,.lbd2-lines');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 2. Parallaxe + scènes pinned ------------------ */
  var parallax = [];
  var scenes = [];
  var ticking = false;

  function collectMotion(scope) {
    var root = scope || document;
    root.querySelectorAll('.lbd2-par').forEach(function (el) {
      if (el.__lbd) return; el.__lbd = 1;
      parallax.push({ el: el, img: el.querySelector('img'), amp: parseFloat(el.dataset.amp || '40') });
    });
    root.querySelectorAll('[data-lbd-scene]').forEach(function (el) {
      if (el.__lbd) return; el.__lbd = 1;
      scenes.push({ el: el, target: el.querySelector('[data-lbd-scene-target]') });
    });
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var vh = window.innerHeight;

      for (var i = 0; i < parallax.length; i++) {
        var p = parallax[i];
        if (!p.img) continue;
        var r = p.el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) continue;
        // -1 (sous l'écran) → 1 (au-dessus)
        var prog = (vh / 2 - (r.top + r.height / 2)) / (vh / 2 + r.height / 2);
        p.img.style.setProperty('--py', (prog * p.amp).toFixed(1) + 'px');
      }

      for (var j = 0; j < scenes.length; j++) {
        var s = scenes[j];
        if (!s.target) continue;
        var sr = s.el.getBoundingClientRect();
        if (sr.bottom < 0 || sr.top > vh) continue;
        // « t » = progression DANS la scène épinglée (sert à la sortie).
        var total = sr.height - vh;
        var t = total > 0 ? Math.min(1, Math.max(0, -sr.top / total)) : 0;
        // « e » = révélation. Elle doit commencer dès que la section entre
        // dans le viewport : le bloc épinglé est déjà visible bien avant que
        // sr.top ne passe sous zéro. Avec l'ancienne formule (basée sur t) le
        // produit et le texte restaient invisibles pendant tout le premier
        // écran — on voyait un aplat jaune vide.
        var e = Math.min(1, Math.max(0, (vh - sr.top) / (vh * 0.7)));
        e = 1 - Math.pow(1 - e, 3);
        // Une fois la scène nette on fige la valeur et on retire les
        // transformations : garder une grande image en scale permanent coûte
        // cher au compositeur.
        var sharp = e > 0.99;
        if (sharp !== s.sharp) {
          s.sharp = sharp;
          s.target.classList.toggle('is-sharp', sharp);
        }
        if (sharp) continue;
        s.target.style.setProperty('--scene', e.toFixed(3));
        s.target.style.setProperty('--scene-out', (1 - t).toFixed(3));
      }
    });
  }

  function initMotion(scope) {
    collectMotion(scope);
    if (reduce) {
      scenes.forEach(function (s) {
        if (s.target) { s.target.style.setProperty('--scene', '1'); s.target.style.setProperty('--scene-out', '1'); }
      });
      return;
    }
    if (parallax.length || scenes.length) {
      onAnyScroll(onScroll);
      onScroll();
    }
  }

  /* ---------- 3. Accordéons --------------------------------- */
  function initAcc(scope) {
    (scope || document).querySelectorAll('.lbd2-acc').forEach(function (acc) {
      if (acc.__lbd) return; acc.__lbd = 1;
      acc.addEventListener('click', function (ev) {
        var q = ev.target.closest('.lbd2-acc__q');
        if (!q || !acc.contains(q)) return;
        var item = q.closest('.lbd2-acc__i');
        var open = item.classList.contains('is-open');
        if (acc.dataset.single !== 'false') {
          acc.querySelectorAll('.lbd2-acc__i.is-open').forEach(function (o) {
            o.classList.remove('is-open');
            var b = o.querySelector('.lbd2-acc__q');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
        }
        item.classList.toggle('is-open', !open);
        q.setAttribute('aria-expanded', String(!open));
      });
    });
  }

  /* ---------- 4. Carrousels horizontaux --------------------- */
  function initRails(scope) {
    (scope || document).querySelectorAll('[data-lbd-rail]').forEach(function (wrap) {
      if (wrap.__lbd) return; wrap.__lbd = 1;
      var rail = wrap.querySelector('.lbd2-rail');
      var prev = wrap.querySelector('[data-rail-prev]');
      var next = wrap.querySelector('[data-rail-next]');
      if (!rail) return;

      function step() {
        var first = rail.querySelector('.lbd2-rail > *:not(.lbd2-rail__pad)');
        return first ? first.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8;
      }
      function sync() {
        if (!prev || !next) return;
        var max = rail.scrollWidth - rail.clientWidth - 2;
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
      rail.addEventListener('scroll', function () {
        clearTimeout(rail.__t);
        rail.__t = setTimeout(sync, 80);
      }, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      sync();
    });
  }

  /* ---------- 5. Indicateur de progression latéral ---------- */
  function initProgress() {
    var rail = document.querySelector('.lbd2-rail-progress');
    if (!rail || reduce) return;
    var marks = rail.querySelectorAll('span');
    if (!marks.length) return;
    var tick = false;
    function upd() {
      if (tick) return; tick = true;
      requestAnimationFrame(function () {
        tick = false;
        var sc = getScroller();
        var h = sc.scrollHeight - sc.clientHeight;
        var p = h > 0 ? sc.scrollTop / h : 0;
        var n = Math.round(p * (marks.length - 1));
        for (var i = 0; i < marks.length; i++) marks[i].classList.toggle('on', i <= n);
      });
    }
    onAnyScroll(upd);
    upd();
  }

  /* ---------- Boot ------------------------------------------ */
  function boot(scope) {
    initReveal(scope);
    initMotion(scope);
    initAcc(scope);
    initRails(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); initProgress(); });
  } else {
    boot(); initProgress();
  }

  // Éditeur de thème Shopify : re-init après rechargement d'une section
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  window.lbd2Boot = boot;
})();
